











// vendor
import { defineComponent } from "@vue/composition-api";
// local
import LoginForm from "./login-form.vue";

export default defineComponent({
	components:{
		LoginForm
	}
});

